<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Vehículos</p>
              <h4 class="card-title">{{totalVehicles}}</h4>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">En Linea</p>
              <h4 class="card-title">{{VehiclesOnline}}</h4>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Desconectados</p>
              <h4 class="card-title">{{VehiclesOffline}}</h4>
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <chart-card v-if="vehicles!=''"
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Encendidos/Apagados</h4>
              <p class="card-category">Contador gráfico de vehículos</p>
            </template>
          </chart-card>
        </div>
        <div class="col-md-6">
          <chart-card v-if="vehicles!=''"
            :chart-data="barChart1.data"
            :chart-options="barChart1.options"
            :chart-responsive-options="barChart1.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Movimiento/Detenidos</h4>
              <p class="card-category">Contador gráfico de vehículos</p>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import firebase from "firebase/app";
  
  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        contador:0,
        totalVehicles: 0,
        VehiclesOnline: 0,
        VehiclesOffline: 0,
        VehiclesOn: 0,
        VehiclesOff: 0,
        token: localStorage.getItem('fcmToken'),
        vehicles:[],
        barChart: {
          data: {
            labels: ['Encendidos', 'Apagados'],
            series: [[0],[0]]
          },
          options: {
            seriesBarDistance: 200,
            axisX: {
              showGrid: true
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart1: {
          data: {
            labels: ['Movimiento', 'Detenido'],
            series: [[0],[0]]
          },
          options: {
            seriesBarDistance: 200,
            axisX: {
              showGrid: true
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
      }
    },
    methods:{
      dataVehicles(){
        this.contador+=1;
        this.totalVehicles=0;
        this.VehiclesOnline=0;
        this.VehiclesOffline=0;
        this.VehiclesOff=0;
        this.VehiclesOn=0;
        this.movingVehicles=0;
        this.stoppedVehicles=0;
        this.date=new Date();
        var numberOfMlSeconds = this.date.getTime();
        var addMlSeconds = 60 * 60000;
        this.endData=new Date(numberOfMlSeconds - addMlSeconds);
        this.vehicles.forEach(vehicle => {
          this.totalVehicles = this.totalVehicles + 1;
          if(vehicle.last_report!=null){
            if(Date.parse(vehicle.last_report) < Date.parse(this.endData))this.VehiclesOffline=this.VehiclesOffline+1;
          }else {this.VehiclesOffline=this.VehiclesOffline+1;
          }
          if(vehicle.last_event==11 || vehicle.last_event==91)this.VehiclesOff=this.VehiclesOff+1;
          else this.VehiclesOn=this.VehiclesOn+1;
          if(vehicle.last_speed!='0' && vehicle.last_speed!=null && vehicle.last_speed!=''){
            this.movingVehicles=this.movingVehicles+1;
          } else{
            this.stoppedVehicles=this.stoppedVehicles+1;
          }
        });
        this.VehiclesOnline=this.totalVehicles-this.VehiclesOffline;
        this.barChart.data.series=[[this.VehiclesOn],[this.VehiclesOff]];
        this.barChart1.data.series=[[this.movingVehicles],[this.stoppedVehicles]];
      },
    },
    
    beforeMount() {
      this.$root.$emit("getList");
      this.$root.$on("send",data=>{
        this.vehicles = data;
        this.dataVehicles();
      });
    },
    mounted () {
      
    }
  }
</script>
<style>

</style>
